import { render, staticRenderFns } from "./Healthy.vue?vue&type=template&id=b1d4c694&scoped=true"
import script from "./Healthy.vue?vue&type=script&lang=js"
export * from "./Healthy.vue?vue&type=script&lang=js"
import style0 from "./Healthy.vue?vue&type=style&index=0&id=b1d4c694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d4c694",
  null
  
)

export default component.exports